<app-loader [isBusy]="isBusy">
    <ng-template>
        <div class="modal-header">
            <h4 class="modal-title">{{ 'Delivery Order' | translate }}</h4>
            <button class="close" type="button" aria-label="Close" (click)="activeModal.close(null)">
                <span aria-hidden="true">&times;</span>
            </button>
        </div>

        <div class="modal-body">
            <app-loader [isBusy]="false">
                <ng-template>
                    <form class="p-3" [formGroup]="form">
                        <div class="row">
                            @if (!vesselVisitId) {
                                <div class="col">
                                    <form-dropdown
                                        labelText="{{ 'Vessel Voyage' | translate }}"
                                        formControlName="vesselVisitId"
                                        displayValue="name"
                                        [observableInput]="vesselVisits$"
                                        (valueChange)="onVesselVisitChange($event)"></form-dropdown>
                                </div>
                            }
                            <div class="col">
                                <form-dropdown
                                    formControlName="relationSystemToOrganizationToTerminalId"
                                    labelText="{{ 'Terminal' | translate }}"
                                    [observableInput]="relationTerminalOptions$"></form-dropdown>
                            </div>
                            <div class="col">
                                <form-dropdown
                                    formControlName="berthId"
                                    labelText="{{ 'Berth' | translate }}"
                                    [observableInput]="berths$"></form-dropdown>
                            </div>
                        </div>
                        <hr />
                        <div class="row">
                            <div class="col-3">
                                <form-dropdown
                                    formControlName="typeId"
                                    labelText="{{ 'Type' | translate }}"
                                    codeListName="DeliveryOrderType"></form-dropdown>
                            </div>
                            <div class="col-3">
                                <form-dropdown
                                    formControlName="serviceProviderId"
                                    labelText="{{ 'Service Provider' | translate }}"
                                    [observableInput]="serviceProviders$"></form-dropdown>
                            </div>
                            <div class="col-3">
                                <form-dropdown
                                    formControlName="launchOperatorId"
                                    labelText="{{ 'Launch Boat Operator' | translate }}"
                                    codeListName="LBOOrganization"></form-dropdown>
                            </div>
                            <div class="col-3">
                                <form-textbox
                                    formControlName="meanOfTransport"
                                    labelText="{{ 'Mean Of Transport' | translate }}"></form-textbox>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-sm-3">
                                <form-datetime
                                    formControlName="deliveryTime"
                                    labelText="{{ 'Expected Delivery Time' | translate }}"></form-datetime>
                            </div>
                            <div class="col-3">
                                <form-textbox formControlName="mrn" labelText="{{ 'MRN' | translate }}"></form-textbox>
                            </div>
                            <div class="col-3">
                                <form-textbox
                                    formControlName="vesselMaster"
                                    labelText="{{ 'Vessel Master' | translate }}"></form-textbox>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col">
                                <form-textbox
                                    formControlName="remarks"
                                    labelText="{{ 'Remarks' | translate }}"></form-textbox>
                            </div>
                        </div>
                        <hr />

                        <!-- Items -->
                        <div class="row">
                            <div class="col-12" formArrayName="items">
                                @for (arrayItem of itemArrayRef?.controls; track arrayItem; let i = $index) {
                                    <div class="mb-3" [formGroupName]="i">
                                        <div class="row align-items-end">
                                            <div class="col-3">
                                                <form-textbox
                                                    labelText="{{ 'Name' | translate }}"
                                                    formControlName="name"></form-textbox>
                                            </div>
                                            <div class="col-6">
                                                <form-textbox
                                                    labelText="{{ 'Description' | translate }}"
                                                    formControlName="description"></form-textbox>
                                            </div>
                                            <div class="col-2">
                                                <form-number
                                                    labelText="{{ 'Quantity' | translate }}"
                                                    formControlName="quantity"
                                                    [emptyIfZero]="true"></form-number>
                                            </div>
                                            <div class="col-md-1 d-flex justify-content-center mb-3">
                                                <button
                                                    class="btn btn-sm btn-danger"
                                                    kendoTooltip
                                                    title="{{ 'Remove' | translate }}"
                                                    (click)="removeItem(i)">
                                                    <fa-icon [icon]="['fas', 'trash']"></fa-icon>
                                                </button>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="col-3">
                                                <form-number
                                                    labelText="{{ 'Gross Weight (kg)' | translate }}"
                                                    formControlName="grossWeight"
                                                    [emptyIfZero]="true"
                                                    [decimal]="true"></form-number>
                                            </div>
                                            <div class="col-3">
                                                <form-number
                                                    labelText="{{ 'Net Weight (kg)' | translate }}"
                                                    formControlName="netWeight"
                                                    [emptyIfZero]="true"
                                                    [decimal]="true"></form-number>
                                            </div>
                                            <div class="col-3">
                                                <form-number
                                                    labelText="{{ 'Volume' | translate }}"
                                                    formControlName="volume"
                                                    [emptyIfZero]="true"
                                                    [decimal]="true"></form-number>
                                            </div>
                                            <div class="col-3">
                                                <form-dropdown
                                                    labelText="{{ 'Volume Unit' | translate }}"
                                                    codeListName="UnitOfMeasureOnlyVolumePerSystem"
                                                    formControlName="volumeUnitOfMeasureId"></form-dropdown>
                                            </div>
                                        </div>
                                    </div>
                                }

                                <div class="row mt-2">
                                    <div class="col-12 d-flex justify-content-start">
                                        <button class="btn btn-sm btn-primary" (click)="addItem()">
                                            <fa-icon class="mr-1" [icon]="['fas', 'plus']"></fa-icon>
                                            {{ 'Add' | translate }}
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </form>
                </ng-template>
            </app-loader>
        </div>

        <div class="modal-footer">
            <button class="btn btn-sm btn-primary mr-2" [disabled]="form.invalid" (click)="addNewDeliveryOrder()">
                <fa-icon [icon]="['fas', 'check']"></fa-icon>
                &nbsp;&nbsp;{{ 'Save' | translate }}
            </button>
            <button class="btn btn-sm btn-secondary" (click)="activeModal.close(false)">
                <fa-icon [icon]="['fas', 'times']"></fa-icon>
                &nbsp;&nbsp;{{ 'Cancel' | translate }}
            </button>
        </div>
    </ng-template>
</app-loader>
